export const modules = {toolbar: {container: [[{ 'header': [1, 2, 3, 4,false] }],
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{'list': 'ordered'}, {'list': 'bullet'}],
                                        [{ 'indent': '-1'}, { 'indent': '+1' }]]}};

export const max_size_attachements = 100000000 ;

export function replaceTags(texte) {
  ['<h1>','</h1>','<h2>','</h2>','<h3>','</h3>','<p>','</strong>',
  '</em>','<u>','</u>','<s>','</s>','</ol>','</ul>',
    '<p class="ql-indent-1">','<p class="ql-indent-2">','<p class="ql-indent-8">',
    '<p class="ql-indent-3">','<p class="ql-indent-4">','<p class="ql-indent-5">',
    '<p class="ql-indent-6">','<p class="ql-indent-7">','<ol>','<ul>','<em>','<li>','<strong>'].forEach(tag=>{texte = texte.replace(new RegExp(tag,'g'),'');});  
    ['</li></ol>','<p><br></p>','</p><br>','<br></p>','</p></li>','<br></li>'].forEach(tag=>{texte = texte.replace(new RegExp(tag,'g'),'\n');});
    ['</p>','</li>','<br>'].forEach(tag=>{texte = texte.replace(new RegExp(tag,'g'),'\n');});
  // ['<ol>','<ul>','<em>','<li>','<strong>'].forEach(tag=>{texte = texte.replace(new RegExp(tag,'g'),'');});
  return texte
}


 const numwithspaces =(num) =>{if(!num){return }
 return  num.replace('+33','0').replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5')  ; 
}


export  const templatemessage_comtoclient =(leadactu, user) =>`
Bonjour ${leadactu.prenom} ${leadactu.nom},<br/><br/><br/><br/>

${user.firstname} ${user.lastname}<br/>
Votre conseiller santé <br/>
${numwithspaces(user.telephone)}` ;

export  const templatemessagetexte_comtoclient =(leadactu, user) =>`
Bonjour ${leadactu.prenom} ${leadactu.nom},

${user.firstname} ${user.lastname}
Votre conseiller santé 
${numwithspaces(user.telephone)}` ;


export  const templatemessage_gestion =( user) =>`
Bonjour  ,<br/><br/><br/><br/>

${user.firstname} ${user.lastname}<br/>
Service Gestion <br/>
${numwithspaces(user.telephone)}` ;

